<template>
    <span :class="['inline-flex items-center px-1.5 py-1 rounded font-medium leading-none', textSize]">
        <slot></slot>
    </span>
</template>

<script>
export default {
    name: "Badge",

    props: {
        textSize: {
            type: String,
            required: false,
            default: "text-xs"
        }
    }
};
</script>

<style scoped>

</style>
